import React from 'react';

// This component helps search engines by providing static, crawlable content
const StaticContentHelper = ({ pageName, services = [], cities = [] }) => {
  return (
    <div style={{ display: 'none' }} className="seo-content">
      {/* Hidden structured content for search engines */}
      <h1>Legal Document Specialist - {pageName}</h1>
      
      {/* Services List for Search Engines */}
      {services.length > 0 && (
        <div>
          <h2>Legal Services Available</h2>
          <ul>
            {services.map((service, index) => (
              <li key={index}>
                <strong>{service.name}</strong>: {service.description}
                <span> - Email specifics to quote@legaldocspecialist.com for a quote</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      
      {/* Cities List for Search Engines */}
      {cities.length > 0 && (
        <div>
          <h2>Service Areas in California</h2>
          <ul>
            {cities.map((city, index) => (
              <li key={index}>
                Process serving and legal document services in {city}, California
              </li>
            ))}
          </ul>
        </div>
      )}
      
      {/* Contact Information for Search Engines */}
      <div>
        <h2>Contact Information</h2>
        <p>Phone: (760) 866-9182</p>
        <p>Email: support@legaldocspecialist.com</p>
        <p>Address: 225 South Civic Drive, Ste 2-16, Palm Springs, CA 92262</p>
        <p>Business Hours: Monday-Friday 8:00 AM - 6:00 PM PST</p>
      </div>
      
      {/* Business Categories for Search Engines */}
      <div>
        <h2>Business Categories</h2>
        <ul>
          <li>Process Serving Services</li>
          <li>Court Filing Services</li>
          <li>Legal Document Services</li>
          <li>Document Retrieval Services</li>
          <li>Skip Tracing Services</li>
          <li>County Recording Services</li>
          <li>E-Filing Services</li>
          <li>Attorney Services</li>
        </ul>
      </div>
      
      {/* Geographic Coverage for Search Engines */}
      <div>
        <h2>Geographic Coverage</h2>
        <p>Primary Service Area: California</p>
        <p>Specialized Coverage: Coachella Valley, Hi-Desert Region, Central Riverside County</p>
        <p>Counties Served: Riverside County, San Bernardino County, Imperial County</p>
      </div>
    </div>
  );
};

export default StaticContentHelper;